import antdAr from "antd/lib/locale-provider/ar_EG";
import appLocaleData from "react-intl/locale-data/ar";
import enMessages from "../locales/en_US.json";
import arMessages from "../locales/ar_SA.json";

const ArLang = {
  messages: {
    ...enMessages,
    ...arMessages
  },
  antd: antdAr,
  locale: 'ar',
  data: appLocaleData
};
export default ArLang;
